import { filterPanel as filterPanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import { PanelValue } from './panelState'
import getPanelDimensions from './getPanelDimensions'
import { getFieldByFieldName } from '@wix/wix-data-client-common/dist/esm/business-logic/fields/fieldSelectors'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'
import { isSlugFilterAllowedInPage as getIsSlugFilterAllowedInPage } from './isSlugFilterAllowedInPage'
import { DESIGN_SYSTEMS } from '@wix/wix-data-client-common-standalone'

const openAddFilterPanel = async (
  { hostname, editorSdkProxy, i18n, editorType, appApi },
  {
    fields,
    controllerRef,
    controllerType,
    collections,
    isTPACollection,
    selectedCollection,
    origin,
  },
) => {
  const originIsNotMenu = origin !== 'menu'

  const isSlugFilterAllowedInPage = originIsNotMenu
    ? await getIsSlugFilterAllowedInPage({
        editorSdkProxy,
        collection: selectedCollection,
        editorType,
        appApi,
        controllerRef,
      })
    : false

  return editorSdkProxy.editor.openToolPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: filterPanelDef.url,
      editorSdkProxy,
      params: {
        designSystemsToLoad: [DESIGN_SYSTEMS.WDS, DESIGN_SYSTEMS.BASE_UI],
      },
    }),

    title: i18n.t('DATASET_SETTINGS_ADD_FILTER_PANEL_TITLE'),

    initialData: {
      fields,
      controllerRef,
      controllerType,
      collections,
      isTPACollection,
      selectedCollection,
      isSlugFilterAllowedInPage,
      origin,
      allowValueSourceSelection: originIsNotMenu,
    },

    ...getPanelDimensions({
      panelValue: PanelValue.Static({}),
      isSlugFilterAllowedInPage,
      allowValueSourceSelection: originIsNotMenu,
    }),

    noPanelPadding: true,
  })
}

const openEditFilterPanel = async (
  { hostname, editorSdkProxy, i18n, editorType, appApi },
  {
    fields,
    filterExpression,
    controllerRef,
    controllerType,
    collections,
    isTPACollection,
    selectedCollection,
    origin,
  },
) => {
  const originIsNotMenu = origin !== 'menu'

  const field = getFieldByFieldName(fields, filterExpression.field)
  const isSlugFilterAllowedInPage = originIsNotMenu
    ? await getIsSlugFilterAllowedInPage({
        editorSdkProxy,
        collection: selectedCollection,
        editorType,
        appApi,
        controllerRef,
      })
    : false

  return editorSdkProxy.editor.openToolPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: filterPanelDef.url,
      editorSdkProxy,
      params: {
        designSystemsToLoad: [DESIGN_SYSTEMS.WDS, DESIGN_SYSTEMS.BASE_UI],
      },
    }),

    title: i18n.t('DATASET_SETTINGS_EDIT_FILTER_PANEL_TITLE'),

    initialData: {
      fields,
      filterExpression,
      controllerRef,
      controllerType,
      collections,
      isTPACollection,
      selectedCollection,
      isSlugFilterAllowedInPage,
      origin,
      allowValueSourceSelection: originIsNotMenu,
    },

    ...getPanelDimensions({
      panelValue: PanelValue.of({ fields, filterExpression }),
      field,
      isTPACollection,
      isSlugFilterAllowedInPage,
      allowValueSourceSelection: originIsNotMenu,
    }),

    noPanelPadding: true,
  })
}

export { openAddFilterPanel, openEditFilterPanel }
